module.exports = __webpack_public_path__ + "media/images/image_strength_area-4a52b702f6256774398c83486d63648e.jpg";